import { Layout } from 'commons/ui-generator/ContentsHandler';
import React, { memo } from 'react';

// 応募フォームの全体レイアウト
type AuditionFormLayoutProps = {
  layoutConfigs: Layout.LayoutConfigs;
};
const AuditionFormLayout = memo(function AuditionFormLayout({
  layoutConfigs,
  children,
}: React.PropsWithChildren<AuditionFormLayoutProps>) {
  const { style: bodyStyle, keyframes: bodyKeyframes } = Layout.buildLayout(
    layoutConfigs.body,
    'dynamic-keyframes-body'
  );
  console.debug('bodyStyle', bodyStyle, bodyKeyframes);
  const { contents: footerContents, style: footerStyle } = Layout.buildLayout(layoutConfigs.footer);
  console.debug('footerStyle', footerStyle, footerContents);
  return (
    <>
      {bodyKeyframes}
      <main className="px-8" style={bodyStyle}>
        {children}
      </main>
      <footer className="py-2 px-4 text-center border-t-[0.5px]" style={footerStyle}>
        {footerContents}
      </footer>
    </>
  );
});

export default AuditionFormLayout;
